import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function GroupUsers({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M20.79 9.51999C21.58 10.31 21.58 11.59 20.79 12.38C19.99 13.17 18.71 13.17 17.92 12.38C17.12 11.58 17.12 10.3 17.92 9.50999C18.71 8.70999 19.99 8.70999 20.78 9.50899M14.2 5.90999C15.41 7.11999 15.41 9.08999 14.2 10.31C12.98 11.52 11.01 11.52 9.79 10.31C8.57 9.08999 8.57 7.11999 9.79 5.89999C11 4.67999 12.97 4.67999 14.19 5.89999M6.06 9.51999C6.85 10.31 6.85 11.59 6.06 12.38C5.26 13.17 3.98 13.17 3.19 12.38C2.39 11.58 2.39 10.3 3.19 9.50999C3.98 8.70999 5.26 8.70999 6.05 9.50899M23 19V17.9C23 16.51 21.88 15.4 20.5 15.4H19.69M1 19V17.9C1 16.51 2.11 15.4 3.5 15.4H4.3M17.33 19V17.39C17.33 15.45 15.76 13.89 13.83 13.89H10.15C8.21 13.89 6.65 15.45 6.65 17.39V18.99" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default GroupUsers;